import { Box, Icon, Typography } from '@saviynt/design-system';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import { TOKENS } from '../../../../shared/constants';

export type TriggerType = 'agent_registered' | 'labels_change';

export const TRIGGER_LABELS: Record<TriggerType, string> = {
  agent_registered: 'When an agent is registered',
  labels_change: 'When labels change',
};

interface TriggerSelectContentProps {
  onSelect: (trigger: TriggerType) => void;
}

interface TriggerOption {
  type: TriggerType;
  iconKind: string;
  title: React.ReactNode;
  description: React.ReactNode;
}

const TRIGGER_OPTIONS: TriggerOption[] = [
  {
    type: 'agent_registered',
    iconKind: 'Certification',
    title: (
      <FormattedMessage
        id='2s1zEF'
        defaultMessage='When an agent is registered'
        description='Trigger option: agent registered'
      />
    ),
    description: (
      <FormattedMessage
        id='6AT4xZ'
        defaultMessage='Runs when a new agent is added to the system for the first time.'
        description='Trigger option description: agent registered'
      />
    ),
  },
  {
    type: 'labels_change',
    iconKind: 'Tag',
    title: (
      <FormattedMessage
        id='QplHdD'
        defaultMessage='When labels change'
        description='Trigger option: labels change'
      />
    ),
    description: (
      <FormattedMessage
        id='qr+gqX'
        defaultMessage='Runs when a label is added, removed, or updated on an agent.'
        description='Trigger option description: labels change'
      />
    ),
  },
];

export default function TriggerSelectContent({
  onSelect,
}: TriggerSelectContentProps) {
  return (
    <main className='PolicyForm-detail'>
      {/* Panel header */}
      <Box
        className={cx('PolicyForm-panel-surface', 'PolicyForm-panel-header')}>
        <Typography
          kind='h2'
          desktop='h2-d'
          mobile='h2-d'
          color={TOKENS.CF_NEU_BLD}>
          <FormattedMessage
            id='/pyDv6'
            defaultMessage='When should this rule run?'
          />
        </Typography>
        <Typography kind='body2' color={TOKENS.CF_NEU_STL}>
          <FormattedMessage
            id='rm2FYy'
            defaultMessage='Choose what should trigger this rule'
            description='Subtitle for trigger selection screen'
          />
        </Typography>
      </Box>

      {/* Trigger options */}
      <Box className={cx('PolicyForm-panel-surface', 'PolicyForm-panel-body')}>
        {TRIGGER_OPTIONS.map((option) => (
          <button
            key={option.type}
            type='button'
            onClick={() => onSelect(option.type)}
            className='PolicyForm-trigger-card'>
            <Icon
              kind={option.iconKind as Parameters<typeof Icon>[0]['kind']}
              size='medium'
              color={TOKENS.CF_INF_BLD}
            />
            <Box className='PolicyForm-trigger-cardText'>
              <Typography kind='h3' color={TOKENS.CF_NEU_BLD}>
                {option.title}
              </Typography>
              <Typography kind='body2' color={TOKENS.CF_NEU_STL}>
                {option.description}
              </Typography>
            </Box>
            <Icon kind='ArrowRight' size='medium' color={TOKENS.CF_NEU_BLD} />
          </button>
        ))}
      </Box>
    </main>
  );
}
